export default "__VITE_ASSET__C2Gv_jrV__"